/**
 * @generated SignedSource<<d422a87306c461f3cfa59110a416d6bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuDrawer_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRefineMenuSelector_user">;
  readonly " $fragmentType": "SbRespRefineMenuDrawer_user";
};
export type SbRespRefineMenuDrawer_user$key = {
  readonly " $data"?: SbRespRefineMenuDrawer_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRefineMenuDrawer_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineMenuDrawer_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuSelector_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "3325498040db22a6b31030fa564e2e90";

export default node;
